import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';

import { BackdropProgress, Icon, ICON_LIST } from 'Components/Base';
import ButtonIcon from 'Components/ButtonIcon';
import { useAnalytics } from 'Libs/Analytics';
import * as mixpanel from 'config/mixpanel';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import ExportLearningResultReportData from 'Domains/ExportLearningResultReportData';

const LearningResultExporter = ({
  disabled,
  appliedFilter,
  schoolCode,
  onLogAction,
  myProfileId,
}) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('learningResult');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    term: { id: schoolTermId } = {},
    grade: { id: schoolGradeId } = {},
    classNo: { classNo } = {},
    subject: { id: subjectId, name: subjectName } = {},
    syllabus: { courseCode } = {},
    lesson: { sectionCode } = {},
    activeBar,
  } = appliedFilter;

  const handleClose = () => {
    setOpen(false);
  };

  const handleExportLearningResultReport = async (
    fetchLearningResultReportData,
    exportLearningResultReport
  ) => {
    onLogAction({
      category: 'Export',
      action: `Click`,
      label: `Click on learning result page`,
    });
    send('export', { on: 'section_page' });
    mixpanel.trackEvent('Section Export File 1st Exam Click', {
      distinct_id: myProfileId,
    });
    setLoading(true);
    const { data, error } = await fetchLearningResultReportData();
    setLoading(false);
    if (!error) {
      await exportLearningResultReport({
        data: data.foLearningResultReportExport,
        type: 'xlsx',
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <ExportLearningResultReportData
      schoolTermId={schoolTermId}
      schoolGradeId={appliedFilter.grade !== `all-grade-selected` ? schoolGradeId : null}
      classNo={appliedFilter.classNo !== `all-class-selected` ? classNo : null}
      subjectId={subjectId}
      courseCode={appliedFilter.syllabus !== `all-syllabus-selected` ? courseCode : null}
      lessonId={
        appliedFilter.lesson && appliedFilter.lesson !== `all-lesson-selected` ? sectionCode : null
      }
      schoolCode={schoolCode}
      activeBar={activeBar}
    >
      {({ fetchLearningResultReportData, exportLearningResultReport }) => {
        return (
          <Fragment>
            <BackdropProgress open={loading} />
            <ButtonOutlinedIcon
              leftIcon={<Icon name={ICON_LIST.EXPORT} />}
              lineHeight={'0.5'}
              textProp={{
                fontWeight: 'semibold',
              }}
              height={'40px'}
              message={t('EXPORT')}
              disabled={disabled || loading}
              onClick={() => {
                handleExportLearningResultReport(
                  fetchLearningResultReportData,
                  exportLearningResultReport
                );
              }}
            />
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{t('EXPORT_ERROR_TITLE')}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t('EXPORT_ERROR_TEXT', { subjectName })}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <ButtonIcon
                  onClick={handleClose}
                  variant={'primary'}
                  lineHeight={'1'}
                  height={'40px'}
                  message={t('SUBMIT')}
                />
              </DialogActions>
            </Dialog>
          </Fragment>
        );
      }}
    </ExportLearningResultReportData>
  );
};

export default withAnalytic(LearningResultExporter);
